import { isAndroid } from "@memorang/helpers/platform";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useAppTheme } from "../../../useAppTheme";
import Box from "../../Box";
import Container from "../../Container";
import StudySessionProgressbar from "../StudySessionProgressbar/StudySessionProgressbar";
import TimerChip from "./TimerChip";

type Props = {
	handleClickRightCta: () => void;
	isAnswered?: boolean;
	currentProgress: number;
	isReportPage?: boolean;
	timerLabel?: string;
	isTimerOverrun?: boolean;
};

const PROGRESS_ROW_HEIGHT = 52;
const TOP_LABEL_GAP = 4;

const FormativeStudySessionAppbar = ({
	handleClickRightCta,
	isAnswered,
	currentProgress,
	isReportPage,
	timerLabel,
	isTimerOverrun,
}: Props) => {
	const theme = useAppTheme();
	const insets = useSafeAreaInsets();

	return (
		<Box backgroundColor={theme.colors.surface} paddingTop={insets.top}>
			<Container maxWidth={"lg"} autoSize>
				<Box
					width="100%"
					paddingHorizontal={16}
					paddingTop={isAndroid ? 16 : 8}
					paddingBottom={8}
				>
					<Box height={PROGRESS_ROW_HEIGHT}>
						<StudySessionProgressbar
							showClose
							fullWidth
							handleSelectClose={handleClickRightCta}
							isAnswered={isAnswered}
							currentProgress={currentProgress}
							isReportPage={isReportPage}
						/>
					</Box>
					{timerLabel ? (
						<Box alignItems="center" paddingTop={TOP_LABEL_GAP}>
							<TimerChip
								label={timerLabel}
								isAlert={isTimerOverrun}
								minWidth={0}
								compact
							/>
						</Box>
					) : null}
				</Box>
			</Container>
		</Box>
	);
};

export default FormativeStudySessionAppbar;
